export const FETCH_REPORT = 'FETCH_REPORT';
export const SAVE_REPORT = 'SAVE_REPORT';
export const RESET_STATE ='RESET_STATE';
export const CUSTOM_REPORT_FETCH_CHART = 'CUSTOM_REPORT_FETCH_CHART';
export const CUSTOM_REPORT_SAVE_BOT_STATUS ='CUSTOM_REPORT_SAVE_BOT_STATUS';
export const CUSTOM_REPORT_SAVE_BOT_CHARTS ='CUSTOM_REPORT_SAVE_BOT_CHARTS';
export const CUSTOM_REPORT_CREATE_BOT ='CUSTOM_REPORT_CREATE_BOT';
export const FETCH_JOURNEY_REPORT_METADATA ='FETCH_JOURNEY_REPORT_METADATA';
export const SAVE_JOURNEY_REPORT_METADATA ='SAVE_JOURNEY_REPORT_METADATA';